/** Query keys, in one place so invalidation stays consistent. */
export const qk = {
  session: ['session'] as const,
  overview: ['overview'] as const,
  groups: ['groups'] as const,
  group: (id: string) => ['group', id] as const,
  groupFeed: (id: string) => ['groupFeed', id] as const,
  groupBalances: (id: string) => ['groupBalances', id] as const,
  people: ['people'] as const,
  person: (userId: string) => ['person', userId] as const,
  userProfile: (id: string) => ['userProfile', id] as const,
  expense: (id: string) => ['expense', id] as const,
  settlement: (id: string) => ['settlement', id] as const,
  activity: (groupId: string | null) => ['activity', groupId ?? 'all'] as const,
  notifications: ['notifications'] as const,
  attention: ['notifications', 'actionable'] as const,
  unreadCount: ['unreadCount'] as const,
  notificationPrefs: ['notificationPrefs'] as const,
  pushStatus: ['pushStatus'] as const,
  fx: (date: string | null) => ['fx', date ?? 'latest'] as const,
  sessions: ['sessions'] as const,
  passkeys: ['passkeys'] as const,
  adminInvites: ['admin', 'invites'] as const,
  myInvites: ['invites', 'mine'] as const,
  adminUsers: ['admin', 'users'] as const,
  invitePreview: (code: string) => ['invitePreview', code] as const,
  joinPreview: (token: string) => ['joinPreview', token] as const,
};

/** Mutation keys for offline-capable mutations (resumed after reload). */
export const mk = {
  createExpense: ['createExpense'] as const,
  updateExpense: ['updateExpense'] as const,
  uploadReceipt: ['uploadReceipt'] as const,
  deleteExpense: ['deleteExpense'] as const,
  createSettlement: ['createSettlement'] as const,
  confirmSettlement: ['confirmSettlement'] as const,
  rejectSettlement: ['rejectSettlement'] as const,
  markRead: ['markRead'] as const,
  markAllRead: ['markAllRead'] as const,
};
